import type { CommandView } from "@racler/protocol";

/** Display helpers for command cards (pure; unit-tested). */

/** Shell-like rendering for DISPLAY only. Arguments with spaces/specials are quoted so the user sees argv boundaries. */
export function commandLine(c: Pick<CommandView, "executable" | "args">): string {
  const q = (a: string) => (a === "" || /[^\w@%+=:,./-]/.test(a) ? `'${a.replace(/'/g, `'\\''`)}'` : a);
  return [c.executable, ...c.args].map(q).join(" ");
}

export function commandStatusText(c: Pick<CommandView, "status" | "result" | "error">): string {
  const ms = c.result ? ` · ${formatDuration(c.result.durationMs)}` : "";
  switch (c.status) {
    case "pending_approval":
      return "Waiting for your approval";
    case "running":
      return "Running…";
    case "completed":
      return c.result?.exitCode === 0
        ? `Completed${ms}`
        : `Exited with code ${c.result?.exitCode ?? "?"}${ms}`;
    case "failed":
      return c.error ?? "Failed to run";
    case "timed_out":
      return `Timed out${ms}`;
    case "cancelled":
      return `Stopped${ms}`;
    case "denied":
      return "Denied — not run";
    case "expired":
      return "Expired — not run";
  }
}

export function formatDuration(ms: number): string {
  return ms < 1000 ? `${ms} ms` : ms < 60_000 ? `${(ms / 1000).toFixed(1)} s` : `${Math.round(ms / 1000)} s`;
}

export const commandOk = (c: Pick<CommandView, "status" | "result">) =>
  c.status === "completed" && c.result?.exitCode === 0;

export const policyLabel = (c: Pick<CommandView, "policy">) =>
  c.policy === "allow" ? "Allowed automatically (read-only)" : "Approval required";
